import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSession } from "next-auth/react";
import { toast } from "react-toastify";

import { editOrder } from "@/features/order/actions/edit-order";
import { AmendAction } from "@/features/order/helpers/OrderAmendService";

export function useEditOrderMutation() {
  const { data: session } = useSession();
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: AmendAction) => {
      if (!session) return;
      return editOrder(session, payload);
    },
    {
      mutationKey: ["ORDER_EDIT"],
      onSuccess: (orderEdit) => {
        if (!orderEdit) return;
        queryClient.invalidateQueries({ queryKey: ["ORDER_EDIT", orderEdit.resource.id] });
      },
      onError: (data: Error) => {
        toast.error("Error amending order item: " + data.message);
      },
    },
  );
}
